import FormItem from "components/Utility/FormItem/FormItem";
import InputText from "components/Utility/Input/InputText/InputText";
import Modal from "components/Utility/Modal/Modal";
import logger from "helpers/logger";
import { Notification } from "models/Notification";
import React, { PropsWithChildren, useState } from "react";
import "./NotificationForm.scss";
const SendNotificationModal = (props: PropsWithChildren<INotification>) => {
  const {
    isOpen,
    notification,
    confirm,
    cancel,
    onChangeTitle,
    onChangeContent,
    onChangeImage,
    onChangeLink,
  } = props;

  const [isTitleValid, setIsTitleValid] = useState(!!notification.title);
  const [isContentValid, setIsContentValid] = useState(!!notification.content);
  const [isLinkValid, setIsLinkValid] = useState(true);

  const handleConfirm = React.useCallback(() => {
    if (isTitleValid && isContentValid && isLinkValid) {
      confirm();
    } else {
      logger.error("Vui lòng kiểm tra lại các trường nhập liệu.");
    }
  }, [isTitleValid, isContentValid, isLinkValid, confirm]);

  const handleCancel = React.useCallback(() => {
    cancel();
  }, [cancel]);

  const validateLink = (link: string) => {
    if (!link) return true;
    const linkPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(:\d+)?(\/.*)?$/;
    return linkPattern.test(link);
  };
  return (
    <>
      <Modal
        title={null}
        onCancel={handleCancel}
        visible={isOpen}
        width={585}
        visibleFooter={false}
        closable={false}
      >
        <div className="forgot-password-modal__contaier d-flex flex-column">
          <div className="forgot-password-modal__header">Thông báo</div>
          <div className="forgot-password-content w-100 mt-4">
            <FormItem label={"Tiêu đề"}>
              <InputText
                isMaterial={true}
                value={notification.title}
                placeHolder={"Nhập tiêu đề"}
                onChange={(value) => {
                  setIsTitleValid(!!value.trim());
                  onChangeTitle(value);
                }}
              />
            </FormItem>
            {!isTitleValid && (
              <div className="error-message">Tiêu đề là bắt buộc.</div>
            )}
          </div>
          <div className="forgot-password-content w-100 mt-2">
            <FormItem label={"Nội dung"}>
              <InputText
                isMaterial={true}
                value={notification.content}
                placeHolder={"Nhập nội dung"}
                onChange={(value) => {
                  setIsContentValid(!!value.trim());
                  onChangeContent?.(value);
                }}
              />
            </FormItem>
            {!isContentValid && (
              <div className="error-message"> Nội dung là bắt buộc. </div>
            )}
          </div>
          <div className="forgot-password-content w-100 mt-2">
            <FormItem label={"Ảnh"}>
              <InputText
                isMaterial={true}
                value={notification.imageUrl}
                placeHolder={"Nhập đường dẫn ảnh"}
                onChange={onChangeImage}
              />
            </FormItem>
          </div>
          <div className="forgot-password-content w-100 mt-2">
            <FormItem label={"Link"}>
              <InputText
                isMaterial={true}
                value={notification.link}
                placeHolder={"Nhập link"}
                onChange={(value) => {
                  setIsLinkValid(validateLink(value));
                  onChangeLink?.(value);
                }}
              />
            </FormItem>
            {!isLinkValid && (
              <div className="error-message">Link không hợp lệ.</div>
            )}
          </div>
          <div className="forgot-password-footer d-flex mt-3">
            <button
              className={`btn-save mr-2 ${
                !isTitleValid || !isContentValid ? "disabled" : ""
              }`}
              onClick={handleConfirm}
              disabled={!isTitleValid || !isContentValid || !isLinkValid}
            >
              <span>
                <i className="tio-send_outlined"></i> Gửi
              </span>
            </button>
            <button className="btn-cancel" onClick={handleCancel}>
              <span>
                <i className="tio-clear"></i> Đóng
              </span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

interface INotification {
  isOpen: boolean;
  // [Review] Coding convention, sử dụng camelCase cho tên biến và hàm
  // [Dev] Đánh giá sửa sau
  notification: Notification;
  confirm: () => void;
  cancel: () => void;
  //
  onChangeTitle?: (value: string) => void;
  onChangeContent?: (value: string) => void;
  onChangeImage?: (value: string) => void;
  onChangeLink?: (value: string) => void;
}

export default SendNotificationModal;
